import React from "react";
import "./ErrorPage.scss";

const ErrorPage = ({ errorMessage }) => {
  return (
    <div className="tmx-errorPage">
      <div className="tmx-messenger__title">{errorMessage}</div>
    </div>
  );
};

export default ErrorPage;
